import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "rht_cart";
export const FREE_SHIP_THRESHOLD = 55;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  // variant must include: id, size, color, price, image
  const addItem = (product, variant, quantity = 1) => {
    if (!variant || !variant.id) return;
    setItems((prev) => {
      const found = prev.find((i) => i.key === variant.id);
      if (found) {
        return prev.map((i) => i.key === variant.id ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, {
        key: variant.id,
        variantId: variant.id,
        product_id: product.slug,
        name: product.name,
        price: variant.price ?? product.price,
        image: variant.image || product.image,
        size: variant.size || "OS",
        color: variant.color || null,
        quantity,
      }];
    });
    setOpen(true);
  };

  const updateQty = (key, quantity) => {
    if (quantity <= 0) return removeItem(key);
    setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity } : i));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
